export default {"src":"/_next/static/media/suggest-add.ff2cb93e.svg","height":32,"width":32};